var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 15.9956,
    viewBox: "0 0 16 15.9956",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 15.9953C7.16352 15.9953 0 8.8339 0 0L16 0L16 15.9953Z",
    fill: "#D6A102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 11.9954C0 9.7862 1.79081 7.99539 4 7.99539C6.20919 7.99539 8 9.7862 8 11.9954C8 14.2046 6.20919 15.9954 4 15.9954C1.79081 15.9954 0 14.2046 0 11.9954Z",
    fill: "#274766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif19);
export default __webpack_public_path__ + "static/media/motif-19.939cf584534eb15a55ffcbc6b887fc9a.svg";
export { ForwardRef as ReactComponent };